// extracted by mini-css-extract-plugin
export default {"brandPromo":"tF-z","carousel":"uF-z"};